export default __webpack_public_path__ + "media/zurb/img/home/Facebook-df4225e4a3278127cbfe9e56554a6ba1.png";